import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ganador-so3',
  templateUrl: './ganador-so3.component.html',
  styleUrls: ['./ganador-so3.component.scss']
})
export class GanadorSo3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
